<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Regras">
      <RegrasAba />
    </CTab>
    <CTab title="Carteiras">
      <CarteirasAba />
    </CTab>
    <CTab title="Bloqueios">
      <BloqueiosAba />
    </CTab>
    <CTab title="Configurações">
      <ConfiguracoesAba />
    </CTab>
  </CTabs>
</template>

<script>
import RegrasAba from "./RegrasAba.vue";
import CarteirasAba from "./CarteirasAba.vue";
import ConfiguracoesAba from "./ConfiguracoesAba.vue";
import BloqueiosAba from "./BloqueiosAba.vue";

export default {
  name: "cashback",
  components: { RegrasAba, CarteirasAba, BloqueiosAba, ConfiguracoesAba },
};
</script>

<style src="./cashback-tema.css"></style>
